/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_LocalInputs */

const en_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

const fr_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

const de_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokal`)
};

const it_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locale`)
};

const ru_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Местный`)
};

const es_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

const zh_cn2_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当地的`)
};

const ja_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地元`)
};

const hi_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय`)
};

const pt_pt2_spellcheck_engine_local = /** @type {(inputs: Spellcheck_Engine_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

/**
* | output |
* | --- |
* | "Local" |
*
* @param {Spellcheck_Engine_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_local = /** @type {((inputs?: Spellcheck_Engine_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_engine_local(inputs)
	if (locale === "de") return de_spellcheck_engine_local(inputs)
	if (locale === "it") return it_spellcheck_engine_local(inputs)
	if (locale === "ru") return ru_spellcheck_engine_local(inputs)
	if (locale === "es") return es_spellcheck_engine_local(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_engine_local(inputs)
	if (locale === "ja") return ja_spellcheck_engine_local(inputs)
	if (locale === "hi") return hi_spellcheck_engine_local(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_engine_local(inputs)
	return en_spellcheck_engine_local(inputs)
});